import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UsersListComponent} from "./users-list/users-list.component";
import {UserDetailsComponent} from "./user-details/user-details.component";
import {RouterLink} from "@angular/router";
import {MatCardContent, MatCardModule} from "@angular/material/card";
import {MatMenuModule} from "@angular/material/menu";
import {MatButtonModule} from "@angular/material/button";
import {MatTableModule} from "@angular/material/table";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatFormField, MatFormFieldModule} from "@angular/material/form-field";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatInputModule} from "@angular/material/input";
import {MatIconModule} from "@angular/material/icon";
import {ColorPickerModule} from "ngx-color-picker";
import {MatRadioModule} from "@angular/material/radio";
import {MatDividerModule} from "@angular/material/divider";

@NgModule({
    declarations: [UsersListComponent, UserDetailsComponent],
    imports: [
        CommonModule,
        RouterLink,
        CommonModule,
        MatCardModule,
        MatMenuModule,
        MatButtonModule,
        MatTableModule,
        MatPaginatorModule,
        MatFormField, MatOption, MatSelect,
        FormsModule, MatFormFieldModule,
        MatInputModule, MatIconModule,
        ReactiveFormsModule, ColorPickerModule,
        MatCardContent,
        MatRadioModule, MatDividerModule,
    ],
    exports: [UsersListComponent, UserDetailsComponent]
})
export class UsersModule {}